/**
 * LongTextInput (textarea) builder — verbatim from v1 (research/03 §10;
 * REQ-ELEM-2). Raw `element.Name` in name="properties[…]" (no quote escape),
 * Placeholder interpolated raw.
 */
import { appState } from "../state/app-state";
import { getConditionalDisplay, getToolTipHtml , getElementWidthClass, t , dirAttr } from "./base";

export function buildTextInput(element: any): string {
  var minValue = element.MinCharacters != undefined ? element.MinCharacters : 0;
  var maxValue =
    element.MaxCharacters != undefined ? element.MaxCharacters : 100000;
  var isrequired = element.isRequired;
  var conditionalDisplay = getConditionalDisplay(element);
  let toolTipHtml = getToolTipHtml(element, "span");

  return (
    "<div class='element" + getElementWidthClass(element) + "' data-element='" +
    element.Identifier +
    "' " +
    conditionalDisplay.conditionalTemplate +
    "><label style='color:" +
    appState.calculatorStyling.upperTextColor +
    "'" + dirAttr(element.Name) + ">" +
    t(element.Name) +
    toolTipHtml +
    "</label><textarea class='calc-prop' data-identifier='" +
    element.Identifier +
    "' data-isrequired='" +
    isrequired +
    "' minlength='" +
    minValue +
    "' maxlength='" +
    maxValue +
    "' onblur='CheckTextInputValidity(this);' data-calcname='" +
    element.Name +
    "' name=\"properties[" +
    element.Name +
    "]\" placeholder='" +
    t(element.Placeholder) +
    "' data-lengthToggle='" +
    element.lengthToggle +
    "'></textarea></div>"
  );
}
